export function VehicleViewHistoryNotesCtrl (
	$scope, 
	$uibModalInstance, 
	item
) {
  $scope.notes = item;

  $scope.close = function () {
    $uibModalInstance.dismiss();
  }
};